module.exports = __webpack_public_path__ + "img/ai-head-icon.ca0c346a.png";